import classNames from "classnames";
import {CatalogCard} from "@/widgets/catalog-card";
import {Product} from "@/entities/product";
import {Link} from "@/shared/ui/Link";
import {useMainHitsCarousel} from "../model/hooks/useMainHitsCarousel";
import {Svg} from "@/shared/ui/Svg";
import {Button} from "@/shared/ui/Button";
import useViewItemBatcher from "@/Hooks/useViewItemBatcher";
import styles from "./MainHitsCarousel.module.scss";

type Props = {
    products: Product[];
    titleSection: string;
    link: string;
    linkName: string;
}

export const MainHitsCarousel = ({products, titleSection, link, linkName}: Props) => {
    const {
        carouselRef,
        onPrevButtonClick,
        onNextButtonClick,
        prevBtnDisabled,
        nextBtnDisabled
    } = useMainHitsCarousel();

    const {registerView} = useViewItemBatcher();

    return (
        <div className={styles.container}>
            <div className={`globalContainer`}>
                <p className={styles.titleSection}>{titleSection}</p>
            </div>
            <div className={styles.carousel}>
                <div className={`globalContainer`}>
                    <div ref={carouselRef} className={styles.carouselViewport}>
                        <div className={styles.carouselContainer}>
                            {products.map((product, i) => {
                                return (
                                    <CatalogCard
                                        key={product.id}
                                        product={product}
                                        className={styles.carouselSlide}
                                        index={i + 1}
                                        registerView={registerView}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </div>
                {products.length > 1 && (
                    <>
                        <button
                            type={`button`}
                            className={classNames(styles.button, styles.prev, {[styles.hidden]: prevBtnDisabled})}
                            onClick={onPrevButtonClick}
                        >
                            <Svg id={`arrowLeft`} className={styles.arrowIcon} />
                        </button>
                        <button
                            type={`button`}
                            className={classNames(styles.button, styles.next, {[styles.hidden]: nextBtnDisabled})}
                            onClick={onNextButtonClick}
                        >
                            <Svg id={`arrowRight`} className={styles.arrowIcon} />
                        </button>
                    </>
                )}
            </div>
            <div className={`globalContainer`}>
                <Link href={link}><Button variant={`tertiary`} fullWidth>{linkName}</Button></Link>
            </div>
        </div>
    );
}
